import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateEquipment } from '@graphql/mutations'

function ManageEquipmentForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createEquipment, { loading }] = useCreateEquipment()

  const onFinish = data => {
    createEquipment({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetEquipmentsQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do equipamento" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar equipamento
      </Button>
    </Form>
  )
}

ManageEquipmentForm.propTypes = {
  afterSubmit: func,
}

ManageEquipmentForm.defaultProps = {
  afterSubmit: null,
}

export default ManageEquipmentForm
